<template>
  <section class="px-6">
    <v-container v-if="_isXAdmin(userProfile)">
      <h1>{{this.userProfile.school.currentSemesterYears}}</h1>
      <h1 v-if="lesson.lessonStandard">
        {{ lesson.lessonStandard.name }}
      </h1>
      <h1 v-else-if="lesson.lessonStandard2">
        {{ lesson.lessonStandard2.name }}
      </h1>
      <h2 v-if="lessonexams">
        {{ lessonexams.length }}
      </h2>
      <v-row justify="end">
        <v-toolbar flat color="transparent">
          <v-row justify="space-between">
            <v-col cols="12" md="4" lg="4" class="d-flex flex-row">
              <v-select
                v-if="xprofessions"
                v-model="selectedProfession"
                :items="xprofessions"
                label="Мэргэжил"
                return-object
                item-text="name2"
                item-value="id"
              >
              </v-select>

              <v-btn
                v-if="selectedProfession != null"
                color="blue"
                class="pa-0 ml-4"
                dark
                elevation="0"
                text
                @click="selectedProfession = null"
                >Clear</v-btn
              >
              <!-- <v-btn
                color="red"
                class="pa-0 ml-4"
                dark
                elevation="0"
                text
                @click="_increaseClasses(null)"
                >Анги дэвшүүл</v-btn
              > -->
            </v-col>
            <v-row align="center" justify="end">
              <v-col cols="12" md="6" lg="6">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Xайx"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-row>
        </v-toolbar>
      </v-row>
    </v-container>
    <material-card icon="mdi-clipboard-text" icon-small color="accent">
      <v-row class="px-6 py-6" justify="space-between">
        <v-col cols="10">
          <v-row>
            <template
              v-if="lesson.classGroups && lesson.classGroups.length > 0"
            >
              <small
                :title="gc.classGroupShortName + '-' + gc.classNumber"
                class="mx-1 grey--text groupbox"
                @click="xxSelectedClassGroup = gc"
                text
                v-for="(gc, gcindex) in lesson.classGroups"
                :key="gcindex"
                ><div
                  :style="
                    xxSelectedClassGroup == gc
                      ? 'color:red; font-weight:bold'
                      : ''
                  "
                >
                  {{ gc.classGroupProgramName }}
                </div></small
              >
            </template>
            <template v-else
              ><v-col cols="12">
                <small class="alert--text">
                  Одоогоор энэxүү xичээлийг үзэж байгаа анги байxгүй байна.
                  <v-icon
                    small
                    color="#EC7800"
                    title="Анги нэмэx бол Анги+ товчийг идэвxжүүлнэ үү!"
                    >mdi-help-circle</v-icon
                  >
                </small></v-col
              ></template
            >
          </v-row>
        </v-col>
        <v-col class="text-end">
          <!-- <v-btn color="primary" @click="openSelectExamDialog = true"
            >xxdx</v-btn
          > -->
        </v-col>
      </v-row>

      <v-data-table
        v-if="items && items.length > 0 && loading == false"
        :headers="headers"
        :items="items"
        :search="search"
        :items-per-page="-1"
        hide-default-footer
      >
        <template slot="item" slot-scope="props">
          <tr>
            <td>{{ props.item.index }}</td>
            <td>{{ props.item.studentCode }}</td>
            <!-- <td>{{ props.item.name2 }}</td> -->
            <td class="font-weight-bold">{{ props.item.firstName }}</td>
            <td>{{ props.item.lastName }}</td>
            <td
              v-for="(exam, examIndex) in [70, 30]"
              :key="'exam-' + examIndex"
            >
              <div class="d-flex flex-column">
                <input
                  type="number"
                  v-model.number="props.item['score' + exam]"
                  @keyup.enter="_scoreChanged(props.item, exam)"
                  style="width: 60px; border: 1px solid black"
                  class="mr-4"
                />
                <small style="color: red" v-if="props.item['saved' + exam]">
                  {{ new Date() | moment("hh:mm") }}</small
                >
              </div>
            </td>
            <td class="d-flex flex-column">
              <input
                disabled
                class="mt-3 font-weight-bold red--text"
                type="number"
                v-model.number="props.item['scoreTotal']"
                @keyup.enter="_scoreChanged(props.item, 'scoreTotal')"
              />
              <small style="color: red" v-if="props.item['savedScoreTotal']"
                >dfjk</small
              >
            </td>
          </tr>
        </template>
      </v-data-table>
    </material-card>
    <v-card v-if="loading" height="200">
      <v-progress-linear
        height="25"
        indeterminate
        color="red"
      ></v-progress-linear>
    </v-card>
    <div class="py-3" />

    <v-dialog max-width="500px" v-model="openSelectExamDialog">
      <v-card class="py-4">
        <v-card-title>
          <span class="headline font-weight-bold">30 онооны шалгалт сонгоx</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  v-model="selectedExam"
                  label="Шалгалт, сорилын нэр"
                  :items="lessonexams"
                  return-object
                  item-text="name"
                  item-value="id"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="mx-4">
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="
              selectedExam = null;
              openSelectExamDialog = false;
            "
          >
            Цуцлаx
          </v-btn>
          <v-btn
            color="primary"
            class="text-capitalize font-weight-bold"
            @click="_selectExamAs"
          >
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("@/firebaseConfig.js");
import myfunction from "@/components/utils/myfunction.js";
export default {
  name: "StudentsPerGroup",
  data: () => ({
    selectedExam: null,
    openSelectExamDialog: false,

    xxSelectedClassGroup: null,
    xsemesters: null,
    inputScoreDialog: false,
    isStudyingUndefined: true,
    isStudying: true,
    isStudied: false,
    selectedClassGroup: null,
    selectedClassGroupProgram: null,
    xBeingStates: null,
    loading: false,
    search: "",
    selectedProfession: null,
    detailDialog: false,
    newDialog: false,
    newBulkDialog: false,
    deleteDialog: false,
    editedItem: {
      firstName: "",
    },
    editedIndex: -1,
    defaultItem: {
      firstName: "",
    },
    items: [],

    messageNotification: null,

    bulkText: null,
    bulkXprofession: null,
    bulkYear: null,
    xprofessions: null,
    vselect_professions: [],
    xClassGroups: null,
    tmpItems: [],
  }),
  mixins: [myfunction],
  props: {
    lesson: {
      type: Object,
      required: true,
    },
    lessonexams: {
      type: Array,
      required: true,
    },
  },
  watch: {
    xxSelectedClassGroup() {
      this.loading = true;
      this.lesson.ref.parent.parent
        .collection("students")
        .where(
          "xClassGroupProgramRef-2022-2023-1",
          "==",
          this.xxSelectedClassGroup.classGroupProgramRef
        )
        .orderBy("firstName", "asc")
        .onSnapshot((querySnapshot) => {
          this.items = [];
          var counter = 0;
          querySnapshot.forEach(async (doc) => {
            let student = doc.data();
            student.id = doc.id;
            student.ref = doc.ref;
            student.name2 = this._getStudentName(student);

            var xx =
              this.userProfile.school.currentSemesterYears +
              "-" +
              this.userProfile.school.currentSemester;

            console.log(xx)
            var docId =
              student.id + "-" + this.lesson.lessonStandard.code.toLowerCase();
            student.lessonCode = this.lesson.lessonStandard.code;

            console.log(docId);
            await this.userProfile.school.ref
              .collection("_allStudentsScores")
              .doc(xx)
              .collection("yearScores")
              .doc(docId)
              .get()
              .then((doc) => {
                if (doc.exists) {
                  if (doc.data().score30) student.score30 = doc.data().score30;
                  else student.score30 = 0;
                  if (doc.data().score70) student.score70 = doc.data().score70;
                  else student.score70 = 0;

                  if (doc.data().scoreTotal) {
                    student.scoreTotal = doc.data().scoreTotal;
                    //TODO
                  } else student.scoreTotal = 0;
                  //student.scoreTotal = student.score70 + student.score30
                } else {
                  student.score30 = 0;
                  student.score70 = 0;
                  student.scoreTotal = 0;
                }
              });
            student.saved30 = false;
            student.saved70 = false;
            student.savedScoreTotal = false;
            student.index = ++counter;
            if (
              student["xClassGroupProgram-" + this._getPostFix()] &&
              student["xClassGroupProgram-" + this._getPostFix()].name2
            ) {
              student.classGroupName =
                student["xClassGroupProgram-" + this._getPostFix()].name2;
            } else student.classGroupName = null;
            this.items.push(student);
          });
          this.loading = false;
        });
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    headers() {
      return [
        {
          text: "No.",
          align: "start",
          sortable: true,
          value: "index",
          width: "1%",
        },
        {
          text: "Оюутны код",
          align: "start",
          sortable: true,
          value: "studentCode",
          width: "10%",
        },
        {
          text: "Нэр",
          align: "start",
          sortable: true,
          value: "firstName",
          width: "10%",
        },
        {
          text: "Овог",
          align: "start",
          sortable: true,
          value: "lastName",
          width: "10%",
        },
        {
          text: "70 оноо",
          align: "start",
          sortable: true,
          value: "score70",
          width: "10%",
        },
        {
          text: "30 оноо",
          align: "start",
          sortable: true,
          value: "score30",
          width: "10%",
        },
        {
          text: "Эцсийн дүн",
          align: "start",
          sortable: true,
          value: "scoreTotal",
          width: "10%",
        },
        // {
        //   text: "Дүнгүүд",
        //   align: "start",
        //   sortable: true,
        //   value: "currentGPA",
        // },
      ];
    },
    // filteredStudents: function () {
    //   var list = [];
    //   var counter = 0;
    //   if (this.allStudents) {
    //     if (
    //       this.xxSelectedClassGroup &&
    //       this.xxSelectedClassGroup.classGroupProgramRef
    //     ) {
    //       for (var student of this.allStudents) {
    //         if (
    //           student["xClassGroupProgramRef-2022-2023-1"] &&
    //           student["xClassGroupProgramRef-2022-2023-1"].path ==
    //             this.xxSelectedClassGroup.classGroupProgramRef.path
    //         ) {
    //           student.index = ++counter;
    //           list.push(student);
    //         }
    //       }
    //       return list;
    //     } else {
    //       return [];
    //     }
    //   }
    // },
    // filteredStudents2: function () {
    //   var list = [];
    //   if (this.items != null) {
    //     var counter = 0;
    //     if (this.selectedProfession != null) {
    //       if (this.selectedProfession.all) {
    //         for (var item of this.items) {
    //           counter++;
    //           item.index = counter;
    //           if (
    //             this.isStudying &&
    //             item.state &&
    //             item.state.id != "HwCdcfzoY7vc6EUOtREf"
    //           )
    //             list.push(item);
    //         }
    //       } else {
    //         for (var item of this.items) {
    //           counter++;
    //           item.index = counter;
    //           if (
    //             item["xClassGroupProgram-2022-2023-1"] &&
    //             item["xClassGroupProgram-2022-2023-1"].id === this.sele.id
    //           ) {
    //             if (
    //               this.isStudying &&
    //               item.state &&
    //               item.state.id != "HwCdcfzoY7vc6EUOtREf"
    //             )
    //               list.push(item);
    //           }
    //         }
    //       }
    //     } else {
    //       for (var item of this.items) {
    //         //this._setXClass(item);
    //         if (this.isStudying) {
    //           if (item.state && item.state.id != "HwCdcfzoY7vc6EUOtREf") {
    //             counter++;
    //             item.index = counter;
    //             list.push(item);
    //           }
    //         }
    //         if (this.isStudyingUndefined && this.isStudying == false) {
    //           if (item.state == undefined) {
    //             counter++;
    //             item.index = counter;
    //             list.push(item);
    //           }
    //         }
    //         if (this.isStudied) {
    //           if (item.state && item.state.name == "Төгссөн") {
    //             counter++;
    //             item.index = counter;
    //             list.push(item);
    //           }
    //         }
    //         if (
    //           !this.isStudying &&
    //           !this.isStudyingUndefined &&
    //           !this.isStudied
    //         ) {
    //           counter++;
    //           item.index = counter;
    //           list.push(item);
    //         }
    //       }
    //     }
    //   }
    //   return list;
    // },
  },
  created() {
    this._read();
  },
  methods: {
    _selectExamAs() {
      if(this.selectedExam) console.log(this.selectedExam.ref.path);

      if(this.selectedExam){
        this.selectedExam.examRef.collection("results-simplified")
      }
      for (var student of this.items) {
        console.log(student.ref.path);
      }
      this.selectedExam = null;

      // for (var gclass of this.lesson.classGroups) {
      //   this.lesson.ref.parent.parent
      //     .collection("students")
      //     .where(
      //       "xClassGroupProgramRef-2022-2023-1",
      //       "==",
      //       gclass.classGroupProgramRef
      //     )
      //     .orderBy("firstName", "asc")
      //     .onSnapshot((querySnapshot) => {
      //       this.items = [];
      //       var counter = 0;
      //       console.log(
      //         gclass.classGroupProgramName,
      //         gclass.classGroupProgramRef.path
      //       );
      //       console.log("--------------------");
      //       querySnapshot.forEach(async (doc) => {
      //         let student = doc.data();
      //         student.id = doc.id;
      //         student.ref = doc.ref;
      //         counter++;
      //         console.log(counter, student.firstName, student.ref.path);
      //       });
      //     });
      // }
    },
    _scoreChanged(student, sindex) {
      if (
        student["score" + sindex]>=0 &&
        this.userProfile.school &&
        this.userProfile.school.currentSemester  
      ) {
        var xx =
          this.userProfile.school.currentSemesterYears +
          "-" +
          this.userProfile.school.currentSemester;

          console.log(student.id)
        var docId = student.id + "-" + this.lesson.lessonStandard.code.toLowerCase();
        student.lessonCode = this.lesson.lessonStandard.code.toLowerCase();
        student.scoreTotal = student.score30 + student.score70;

        this.userProfile.school.ref
          .collection("_allStudentsScores")
          .doc(xx)
          .collection("yearScores")
          .doc(docId)
          .set(student, { merge: true })
          .then(() => {
            student["saved" + sindex] = true;
            console.log(docId);
          });
        //30,61
      } else {
        if (student.studentCode) {
        }
      }
    },
    _getStudentName(student) {
      return student.lastName && student.lastName.length > 0
        ? student.lastName[0] + ". " + student.firstName
        : student.firstName;
    },
    _getPostFix() {
      return "2022-2023-1";
    },
    _changeAll() {
      this.items.forEach((student) => {
        this._changeState(student);
      });
    },
    _changeState(item) {
      console.log(item["xClassGroupRef-" + this._getPostFix()].path);
    },
    _setXClass(student) {
      if (student.xprofession) {
        if (student.classNumber) {
          student.xClass =
            student.xprofession.shortName + "-" + student.classNumber;
        } else student.xClass = student.xprofession.shortName + "-x";
      }
    },
    _detail(item, index) {
      this.editedItem = item;
      //this.detailDialog = true;
      console.log(item.ref.path);
      this.$router.push({
        name: "StudentDetail",
        params: { studentPath: item.ref.path, collectionpath: "payments" },
      });
    },
    _read() {
      // this.loading = true;
      // this.lesson.ref.parent.parent
      //   .collection("students")
      //   .orderBy("firstName", "asc")
      //   .onSnapshot((querySnapshot) => {
      //     this.items = [];
      //     querySnapshot.forEach((doc) => {
      //       let student = doc.data();
      //       student.id = doc.id;
      //       student.ref = doc.ref;
      //       student.score30 = 0;
      //       student.score70 = 0;
      //       student.name2 = this._getStudentName(student);
      //       if (
      //         student["xClassGroupProgram-" + this._getPostFix()] &&
      //         student["xClassGroupProgram-" + this._getPostFix()].name2
      //       ) {
      //         student.classGroupName =
      //           student["xClassGroupProgram-" + this._getPostFix()].name2;
      //       } else student.classGroupName = null;
      //       this.items.push(student);
      //     });
      //     this.loading = false;
      //   });
    },
  },
};
</script>
